import React, {Component} from "react";
import styles from './FJMusicLeftMenu.module.less';
import InlineSVG from "react-inlinesvg";
import FiltrateIcon from '../../../../../icon/FiltrateIcon.svg'
import ArrowIcon from '../../../../../icon/arrow-left.svg';
import FJLocalStore from "../../../../../store/FJLocalStore";
import classNames from 'classnames';

function FilterButton(props) {
	return (
		<>
			<div className={styles.btn} onClick={props.onFilterClick}>
				<InlineSVG src={FiltrateIcon}/>
				<span className={styles.filter_text}>{FJLocalStore._('filters')}</span>
			</div>
			<div className={styles.arrow} onClick={props.onFilterClick}>
				<InlineSVG src={ArrowIcon} />
			</div>
		</>
	)
}

class FJMusicLeftMenu extends Component {

	render() {

		let {
			isOpenLeftMenu,
			onFilterClick
		} = this.props;

		return (
			<div className={classNames(styles.filter_container, {[styles.open]: isOpenLeftMenu})}>
				<FilterButton onFilterClick={onFilterClick}/>
			</div>
		)
	}

}

export default FJMusicLeftMenu;